import React, { useEffect, useState } from "react";
import { FaGripLinesVertical, FaUndo } from "react-icons/fa";
import { FiSearch } from "react-icons/fi";
import { RiSave2Fill } from "react-icons/ri";
import { BiRefresh } from "react-icons/bi";
import { IoExitOutline } from "react-icons/io5";
import axios from "axios";
import { API_HOST } from "../api_utils";
import { toast } from "react-toastify";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Box,
  Divider,
  FormControl,
  FormControlLabel,
  Modal,
  Paper,
  Radio,
  RadioGroup,
  Pagination,
  Stack,
} from "@mui/material";
import Loader from "../Shared_Components/Loader";
import { TbArrowBackUp } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

function Products(props) {
  const { userDataFromStorage, coloredTheme } = props;
  let navigate = useNavigate();
  const [productList, setProductList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [productSuccess, setProductSuccess] = useState(false);
  const [editProductSuccess, setEditProductSuccess] = useState(false);
  const [editProductStatus, setEditProductStatus] = useState(null);
  const [filterData, setFilterData] = useState([]);

  // states for filter
  const [inActiveProduct, setInActiveProduct] = useState(true);
  const [filterFrequency, setFilterFrequency] = useState("");
  const [amountLessThan, setAmountLessThan] = useState("");
  const [amountGreaterThan, setAmountGreaterThan] = useState("");

  const [page, setPage] = useState(1);
  const rowsPerPage = 20;
  const [totalPages, setTotalPages] = useState(0);
  const [currentData, setCurrentData] = useState([]);

  const [codeStartsWith, setCodeStartsWith] = useState("");

  // add user by admin state :
  const [loanProductPayload, setLoanProductPayload] = useState({
    amount: "",
    collection_amount: "",
    loan_payment_frequency: "",
    number_of_payments: "",
    stamp_commission: "",
  });

  const handleClose = () => {
    setOpen(false);
  };

  // const getLoanProductList = async () => {
  //   setLoading(true)
  //   const config = {
  //     headers: {
  //       "Content-Type": "application/json",
  //       'Authorization': `Bearer ${userDataFromStorage.token}`
  //     }
  //   }
  //   const { data } = await axios.get(`${API_HOST}/api/loanproducts/get_loan_products`, config);
  //   if (data) {
  //     if (data.message) {
  //       setLoading(false)
  //     } else {
  //       setLoading(false)
  //       setProductList(data)
  //       setFilterData(data)
  //       setCurrentData(data)
  //     }
  //   } else {
  //     setLoading(false)
  //   }
  // }

  const filterProductHandler = async () => {
    setLoading(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userDataFromStorage.token}`,
      },
    };

    let apiUrl = `${API_HOST}/api/loanproducts/get_loan_products`;

    // Construct the query parameters based on available values
    const queryParams = [];
    if (amountGreaterThan) {
      queryParams.push(`greaterThan=${amountGreaterThan}`);
    }
    if (amountLessThan) {
      queryParams.push(`lessThan=${amountLessThan}`);
    }

    queryParams.push(`status=${inActiveProduct}`);

    if (filterFrequency) {
      queryParams.push(`frequency=${filterFrequency}`);
    }

    if (codeStartsWith) {
      queryParams.push(`product_code_starts_with=${codeStartsWith}`);
    }

    if (queryParams.length > 0) {
      apiUrl += `?${queryParams.join("&")}`;
    }

    try {
      const { data } = await axios.get(apiUrl, config);
      if (data && !data.message) {
        setProductList(data);
        setFilterData(data);
        setCurrentData(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    filterProductHandler();
  }, [productSuccess, editProductSuccess]);

  const addProductHandler = async () => {
    if (
      loanProductPayload.amount &&
      loanProductPayload.collection_amount &&
      loanProductPayload.loan_payment_frequency &&
      loanProductPayload.number_of_payments &&
      loanProductPayload.stamp_commission
    ) {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      const { data } = await axios.post(
        `${API_HOST}/api/loanproducts/add_loan_product`,
        loanProductPayload,
        config
      );
      if (data.message) {
        toast.error(data.message);
      } else {
        toast.success("Product Added Successfully !!!");
        setLoading(false);
        setOpen(false);
        setProductSuccess(true);
      }
    } else {
      toast.warn("Please Provide All The Required Fields !!!");
    }
  };

  const editProductHandler = async () => {
    if (editProductStatus) {
      setLoading(true);
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${userDataFromStorage.token}`,
        },
      };

      const payload = {
        productId: editData.id_number,
        active: editProductStatus,
      };

      const { data } = await axios.put(
        `${API_HOST}/api/loanproducts/update_loan_product`,
        payload,
        config
      );
      if (data.message) {
        setLoading(false);
        toast.error(data.message);
      } else {
        toast.success("Product Details Updated Successfully !!!");
        setLoading(false);
        setOpenEdit(false);
        setEditProductSuccess(true);
      }
    } else {
      toast.warn("No Update Action Found !!!");
    }
  };

  useEffect(() => {
    filterProductHandler();
  }, [
    amountGreaterThan,
    amountLessThan,
    inActiveProduct,
    filterFrequency,
    codeStartsWith,
  ]);

  useEffect(() => {
    if (filterData.length) {
      setTotalPages(Math.ceil(filterData.length / rowsPerPage));
      const startIdx = (page - 1) * rowsPerPage;
      const endIdx = startIdx + rowsPerPage;
      console.log("loanHeaderList", filterData.length);
      const currentDataNew = filterData?.slice(startIdx, endIdx);
      setCurrentData(currentDataNew);
    }
  }, [page, filterData]);

  return (
    <div
      className={
        userDataFromStorage.user_role === "admin"
          ? "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden"
          : "xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden"
      }>
      <p className="text-gray-800 text-[1.3rem] md:text-[1.8rem] tracking-wider">
        Loan Product Overview
      </p>

      <div className="bg-white p-[1rem] mt-[2%]">
        <div className="md:flex justify-start items-center">
          <p className="md:w-[25rem] ">Show Inactive Loan Products</p>
          <div className="">
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={inActiveProduct}
                name="radio-buttons-group"
                onChange={(e) => setInActiveProduct(e.target.value === "true")}
                row
                className="text-[0.8rem] md:text-[1rem]">
                <FormControlLabel
                  value={false}
                  control={<Radio className="scale-[80%] md:scale-[100%]" />}
                  label="Yes"
                />
                <FormControlLabel
                  value={true}
                  control={<Radio className="scale-[80%] md:scale-[100%]" />}
                  label="No"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
        <div className="md:flex md:justify-start md:items-center mt-4 md:mt-6">
          <p className="md:w-[25rem]">Loan Amount Greater Than </p>
          <input
            type="number"
            value={amountGreaterThan}
            onChange={(e) => setAmountGreaterThan(parseInt(e.target.value))}
            className="outline-none border border-gray-400 rounded p-[0.3rem] w-[100%] md:w-auto md:flex-grow mt-1 md:mt-0 "
          />
        </div>
        <div className="md:flex justify-start items-center mt-4 md:mt-6">
          <p className="md:w-[25rem]">Loan Amount Less Than </p>
          <input
            type="number"
            value={amountLessThan}
            onChange={(e) => setAmountLessThan(parseInt(e.target.value))}
            className="outline-none mt-1 md:mt-0 border border-gray-400 w-[100%] md:w-auto rounded p-[0.3rem] md:flex-grow"
          />
        </div>

        <div className="md:flex justify-start items-center mt-4 md:mt-6">
          <p className="md:w-[25rem]">Product code Starts with </p>
          <input
            type="number"
            value={codeStartsWith}
            onChange={(e) => setCodeStartsWith(parseInt(e.target.value))}
            className="outline-none mt-1 md:mt-0 border border-gray-400 w-[100%] md:w-auto rounded p-[0.3rem] md:flex-grow"
          />
        </div>

        <div className="md:flex justify-start items-center mt-4 md:mt-6">
          <p className="md:w-[25rem] ">Payment Frequency</p>
          <div>
            <FormControl>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                value={filterFrequency}
                name="radio-buttons-group"
                onChange={(e) => setFilterFrequency(e.target.value)}
                row>
                <FormControlLabel
                  className="text-[0.8rem] "
                  value={"Daily"}
                  control={<Radio className="scale-[75%] md:scale-[100%]" />}
                  label="Daily"
                />
                <FormControlLabel
                  className="text-[0.8rem]"
                  value={"Weekly"}
                  control={<Radio className="scale-[75%] md:scale-[100%]" />}
                  label="Weekly"
                />
                <FormControlLabel
                  className="text-[0.8rem] "
                  value={"Monthly"}
                  control={<Radio className="scale-[75%] md:scale-[100%]" />}
                  label="Monthly"
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>

        <div className="flex justify-start items-center space-x-3 mt-4">
          <button
            onClick={() => filterProductHandler()}
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded text-[0.8rem] md:text-[1rem] space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white  hover:shadow-2xl hover:shadow-black transition duration-[0.6s]">
            <FiSearch className="hidden md:block" />
            <p>Search Products</p>
          </button>
          <button
            onClick={() => {
              setAmountGreaterThan("");
              setAmountLessThan("");
              setInActiveProduct(true);
              setFilterFrequency("");
            }}
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white  hover:shadow-2xl text-[0.8rem] md:text-[1rem] hover:shadow-black transition duration-[0.6s]">
            <FaUndo className="hidden md:block" />
            <p>Reset Search Fields</p>
          </button>
        </div>
      </div>

      <div className="mt-8 w-[100%] overflow-x-scroll">
        <p
          style={{ backgroundColor: coloredTheme }}
          className=" p-[1rem] text-white hidden md:block">
          Loan Product
        </p>
        <div className="overflow-x-scroll w-[100%]">
          <table className="md:w-[100%] w-[350%]">
            <thead className="h-[5vh]">
              <tr>
                <th className="text-center">Product Code</th>
                <th className="text-center">Amount</th>
                <th className="text-center">Collection Amount</th>
                <th className="text-center">Number of Payments</th>
                <th className="text-center">Payment Frequency</th>
                <th className="text-center">Total Due</th>
                <th className="text-center">Stamp Commission</th>
                <th className="text-center">Product Status</th>
              </tr>
            </thead>
            <tbody>
              {currentData.length
                ? currentData.map((x, index) => (
                    <tr
                      onClick={() => {
                        setEditData(x);
                        setOpenEdit(true);
                      }}
                      className={
                        index % 2 === 0
                          ? "bg-white border border-gray-700 "
                          : "border border-gray-700 bg-sky-100"
                      }
                      key={index}>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        {x.product_code}
                      </td>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        MYR {x.amount}
                      </td>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        MYR {x.collection_amount}
                      </td>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        {" "}
                        {x.number_of_payments}
                      </td>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        {x.loan_payment_frequency.charAt(0).toUpperCase() +
                          x.loan_payment_frequency.slice(1)}
                      </td>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        MYR {x.total_due}
                      </td>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        {" "}
                        {x.stamp_commission}
                      </td>
                      <td className="text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]">
                        {x.active === true ? "Active" : "Closed"}
                      </td>
                    </tr>
                  ))
                : "No Products Found !!!"}
            </tbody>
          </table>
        </div>

        <div className=" flex justify-end items-center mt-[2%] px-[0.8rem]">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={(event, newPage) => setPage(newPage)}
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        </div>

        <div className="flex justify-start items-center space-x-4 mt-8 pb-[2rem]">
          {userDataFromStorage.user_role === "admin" ||
          userDataFromStorage.user_role === "manager" ? (
            <button
              onClick={() => setOpen(true)}
              style={{ backgroundColor: coloredTheme }}
              className="flex justify-center items-center px-[1rem] py-[0.5rem]  text-white  space-x-2 rounded hover:shadow-2xl hover:shadow-black transition duration-[0.6s]">
              <RiSave2Fill />
              <p>Add Loan Product</p>
            </button>
          ) : (
            ""
          )}
          <button
            onClick={() => navigate("/home")}
            style={{ backgroundColor: coloredTheme }}
            className="flex justify-center items-center px-[1rem] py-[0.5rem]  text-white  space-x-2 rounded hover:shadow-2xl hover:shadow-black transition duration-[0.6s]">
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div>
      </div>

      {/* add product modal */}
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Loan Product Detail</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                <div className="grid grid-cols-6 ">
                  <label
                    htmlFor="amount"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Amount MYR</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    type="number"
                    id="amount"
                    onChange={(e) =>
                      setLoanProductPayload((prevState) => ({
                        ...prevState,
                        amount: e.target.value,
                      }))
                    }
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter Loan Product Amount"
                  />
                </div>

                <div className="grid grid-cols-6 mt-2">
                  <label
                    htmlFor="collectionAmount"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Collection Amount MYR</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    type="number"
                    id="collectionAmount"
                    onChange={(e) =>
                      setLoanProductPayload((prevState) => ({
                        ...prevState,
                        collection_amount: e.target.value,
                      }))
                    }
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter Collection Amount"
                  />
                </div>

                <div className="grid grid-cols-6 mt-2">
                  <label
                    htmlFor="numberPayment"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Number of Payments</span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    type="number"
                    id="numberPayment"
                    onChange={(e) =>
                      setLoanProductPayload((prevState) => ({
                        ...prevState,
                        number_of_payments: e.target.value,
                      }))
                    }
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter Number of Payments"
                  />
                </div>

                <div className="grid grid-cols-6 mt-2 ">
                  <p className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Payment Frequency</span>
                    <span className="text-red-600 text-lg">*</span>
                  </p>

                  <FormControl className="col-span-4">
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      onChange={(e) =>
                        setLoanProductPayload((prevState) => ({
                          ...prevState,
                          loan_payment_frequency: e.target.value,
                        }))
                      }>
                      <FormControlLabel
                        value="Daily"
                        control={<Radio />}
                        label="Daily"
                      />
                      <FormControlLabel
                        value="Weekly"
                        control={<Radio />}
                        label="Weekly"
                      />
                      <FormControlLabel
                        value="Monthly"
                        control={<Radio />}
                        label="Monthly"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>

                <div className="grid grid-cols-6 mt-2">
                  <label
                    htmlFor="stamp"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">
                      Agent Stamp Commission
                    </span>
                    <span className="text-red-600 text-lg">*</span>
                  </label>
                  <input
                    type="number"
                    id="stamp"
                    onChange={(e) =>
                      setLoanProductPayload((prevState) => ({
                        ...prevState,
                        stamp_commission: e.target.value,
                      }))
                    }
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-4"
                    placeholder="Enter Agent Stamp Commission"
                  />
                </div>

                <div className="mt-3 ">
                  <div className="bg-green-500 p-[0.5rem] rounded-t-lg">
                    <p className="text-white">
                      Expected Returns. Note that the Total Amount Due from the
                      Customer excludes the value of Stamp Duty/Agent Commission
                      that is collected at the start of the loan.
                    </p>
                    <button
                      style={{ backgroundColor: coloredTheme }}
                      className="mt-4 flex justify-center items-center space-x-2 text-white rounded-lg px-[0.8rem] py-[0.5rem]">
                      <BiRefresh className="text-[1.5rem]" />
                      <p>Update Expected Return Data</p>
                    </button>
                  </div>
                  <div className="border-r border-l border-b border-gray-300 p-[0.5rem] rounded-b-lg">
                    <div className="flex justify-between items-center text-gray-500">
                      <p>Total Amount Due From The Customer</p>
                      <p>Not Yet Evaluated</p>
                    </div>
                    <div className="flex justify-between items-center text-gray-500">
                      <p>Expected Base Profit From a Loan</p>
                      <p>Not Yet Evaluated</p>
                    </div>
                  </div>
                </div>

                <div className="flex justify-start items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setOpen(false)}
                    className="flex justify-center items-center space-x-2 text-white px-[1rem] py-[0.5rem] rounded  transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={() => addProductHandler()}
                    style={{ backgroundColor: coloredTheme }}
                    className="flex justify-center items-center space-x-2  px-[1rem] py-[0.5rem] rounded text-white transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Save</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      {/* edit product modal */}
      <Modal
        open={openEdit}
        onClose={() => setOpenEdit(false)}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
        className="flex justify-center items-center overflow-y-scroll mb-[0.5rem]">
        <Box className="md:w-[50%] w-[95%]  rounded-lg bg-white absolute top-[8%] mb-[10rem] ">
          {loading ? (
            <Loader />
          ) : (
            <>
              <div className="p-[0.5rem]">
                <p className="text-lg text-gray-800">Edit Product Detail</p>
              </div>
              <Divider />

              <div className="p-[0.5rem]">
                <div className="grid grid-cols-6 ">
                  <label
                    htmlFor="editAmount"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Amount MYR</span>
                  </label>
                  <input
                    type="number"
                    id="editAmount"
                    value={editData.amount}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-4"
                    disabled
                  />
                </div>

                <div className="grid grid-cols-6 mt-2">
                  <label
                    htmlFor="editCollectionAmount"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Collection Amount MYR</span>
                  </label>
                  <input
                    type="number"
                    id="editCollectionAmount"
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-4"
                    value={editData.collection_amount}
                    disabled
                  />
                </div>

                <div className="grid grid-cols-6 mt-2">
                  <label
                    htmlFor="editNumberPayment"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Number of Payments</span>
                  </label>
                  <input
                    type="number"
                    id="editNumberPayment"
                    value={editData.number_of_payments}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-4"
                    disabled
                  />
                </div>

                <div className="grid grid-cols-6 mt-2">
                  <label
                    htmlFor="editNumberPayment"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Payment Frequency</span>
                  </label>
                  <input
                    type="text"
                    id="editNumberPayment"
                    value={editData.loan_payment_frequency}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-4"
                    disabled
                  />
                </div>

                <div className="grid grid-cols-6 mt-2">
                  <label
                    htmlFor="editstamp"
                    className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">
                      Agent Stamp Commission
                    </span>
                  </label>
                  <input
                    type="number"
                    id="editstamp"
                    value={editData.stamp_commission}
                    className="p-[0.5rem] border border-sky-500 rounded-lg flex-1 outline-none col-span-4"
                    disabled
                  />
                </div>

                <div className="grid grid-cols-6 mt-2 ">
                  <p className="flex justify-start items-center col-span-2 space-x-1">
                    <span className="text-gray-700">Active</span>
                  </p>

                  <FormControl className="col-span-4">
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      value={editData.active}
                      onChange={(e) => {
                        setEditProductStatus(e.target.value);
                        setEditData((prevState) => ({
                          ...prevState,
                          active: e.target.value,
                        }));
                      }}>
                      <FormControlLabel
                        value={true}
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value={false}
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                </div>

                <div className="flex justify-start items-center space-x-4 mt-8 mb-4">
                  <button
                    style={{ backgroundColor: coloredTheme }}
                    onClick={() => setOpenEdit(false)}
                    className="flex justify-center items-center space-x-2 text-white px-[1rem] py-[0.5rem] rounded  transition duration-[0.6s] hover:shadow-2xl hover:shadow-black">
                    <TbArrowBackUp />
                    <p>Cancel</p>
                  </button>
                  <button
                    onClick={() => editProductHandler()}
                    style={{ backgroundColor: coloredTheme }}
                    className="flex justify-center items-center space-x-2  px-[1rem] py-[0.5rem] rounded text-white transition duration-[0.6s] hover:shadow-2xl hover:shadow-black ">
                    <RiSave2Fill />
                    <p>Update Product Detail</p>
                  </button>
                </div>
              </div>
            </>
          )}
        </Box>
      </Modal>

      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />
    </div>
  );
}

export default Products;
